<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.states") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn @click="handleOpenDialog" class="primary mx-2">
        <v-icon small left>mdi-plus</v-icon>
        <span>{{ $t("button.create") }}</span>
      </v-btn>
    </v-toolbar>
    <!-- table -->
    <wrapping-table
      @on_dialog_close="onDialogClose"
      ref="table_ref"
      :headersName="headers"
      :pathName="`countries/${$route.params.id}/states`"
      resName="states"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">
          <v-btn
            :title="$t('icon.cities')"
            icon
            :to="`/countries/${$route.params.id}/states/${item.id}/cities`"
          >
            <v-icon>mdi-city</v-icon>
          </v-btn>
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="states"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          <v-icon
            @click="handleEdit(item, index)"
            small
            :title="$t('icon.edit')"
            >mdi-pencil</v-icon
          >
          <v-icon
            @click="handleDelete(item, index)"
            small
            :title="$t('icon.delete')"
            >mdi-delete</v-icon
          >
        </td>
      </template>
      <!-- dilaog -->
      <template #wrraping_dialog="{ dialog }">
        <form-action
          :isEdit="isEdit"
          :dialog="dialog"
          :table_ref="$refs.table_ref"
          :item="item"
          :index="itemIndex"
        />
      </template>
      <!-- dilaog -->
    </wrapping-table>
    <!-- table -->
  </div>
</template>

<script>
export default {
  name: "States",
  components: {
    FormAction: () => import("./components/FormAction")
  },

  data() {
    return {
      headers: ["name", "cities", "visible", "actions"],
      isEdit: false,
      item: {},
      itemIndex: ""
    };
  },
  methods: {
    onDialogClose() {
      this.isEdit = false;
    },
    handleOpenDialog() {
      this.$refs.table_ref.toggleDialog();
    },

    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleEdit(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = index;
      this.$refs.table_ref.toggleDialog();
    }
  }
};
</script>
